import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { Textarea } from '../ui/textarea'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'

export default function TextAreaField({ label, name, ...props }: { label: string, name: string } & React.ComponentProps<'textarea'>) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                        <Textarea id={name} {...field} {...props} />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}


